/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationAdminMoveGroupMemberRequest
 */
export interface OrganizationAdminMoveGroupMemberRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminMoveGroupMemberRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminMoveGroupMemberRequest
     */
    new_group_name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationAdminMoveGroupMemberRequest
     */
    to_subscribed_list: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminMoveGroupMemberRequest
     */
    user_auth_id: string;
}

/**
 * Check if a given object implements the OrganizationAdminMoveGroupMemberRequest interface.
 */
export function instanceOfOrganizationAdminMoveGroupMemberRequest(value: object): value is OrganizationAdminMoveGroupMemberRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('new_group_name' in value) || value['new_group_name'] === undefined) return false;
    if (!('to_subscribed_list' in value) || value['to_subscribed_list'] === undefined) return false;
    if (!('user_auth_id' in value) || value['user_auth_id'] === undefined) return false;
    return true;
}

export function OrganizationAdminMoveGroupMemberRequestFromJSON(json: any): OrganizationAdminMoveGroupMemberRequest {
    return OrganizationAdminMoveGroupMemberRequestFromJSONTyped(json, false);
}

export function OrganizationAdminMoveGroupMemberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationAdminMoveGroupMemberRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'new_group_name': json['new_group_name'],
        'to_subscribed_list': json['to_subscribed_list'],
        'user_auth_id': json['user_auth_id'],
    };
}

export function OrganizationAdminMoveGroupMemberRequestToJSON(json: any): OrganizationAdminMoveGroupMemberRequest {
    return OrganizationAdminMoveGroupMemberRequestToJSONTyped(json, false);
}

export function OrganizationAdminMoveGroupMemberRequestToJSONTyped(value?: OrganizationAdminMoveGroupMemberRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'new_group_name': value['new_group_name'],
        'to_subscribed_list': value['to_subscribed_list'],
        'user_auth_id': value['user_auth_id'],
    };
}

